import { render } from "./EntitlementUpdateModal.vue?vue&type=template&id=f63c979a&scoped=true"
import script from "./EntitlementUpdateModal.vue?vue&type=script&lang=js"
export * from "./EntitlementUpdateModal.vue?vue&type=script&lang=js"

import "./EntitlementUpdateModal.vue?vue&type=style&index=0&id=f63c979a&scoped=true&lang=css"

import exportComponent from "D:\\fz\\1_Task\\hr.haite.sg\\orangehrm-5.2\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f63c979a"]])

export default __exports__